import timezone from '@/common/timezone';

/**
 * Inject a method into Vue components that allows for easy access
 * to timezone date manipulation. Also attaches the store for the first
 * time to the timezone handler class.
 * @returns {{install: install}}
 * @constructor
 */
export default function TimezoneManager() {
    return {
        /* eslint-disable func-names */
        /* eslint-disable object-shorthand */
        install: function (Vue, {store}) {
            // attach store at runtime to singleton instance
            timezone.attach(store);
            Vue.prototype.$tz = function () {
                return timezone;
            };
        },
    };
}
